module.exports = __webpack_public_path__ + "img/brand.b64dfebc.png";